import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-neutral-950 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_ac879796-0773-4f69-ab14-fe9fd8353425/artifacts/qkbaujxq_fbc3ed1a37eaae10a26408b21a2770a8c17902308430bb9de82e8b9410528a61.png" 
                alt="LBR Distribution" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-neutral-400 text-sm leading-relaxed">
              Revolutionising film distribution. More profit for filmmakers in a broken industry.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg tracking-wider text-white mb-6 uppercase">SERVICES</h4>
            <ul className="space-y-3">
              <li><Link to="/distribution" className="text-neutral-400 hover:text-orange-500 transition-colors text-sm">VOD Distribution</Link></li>
              <li><Link to="/sales" className="text-neutral-400 hover:text-orange-500 transition-colors text-sm">Film Sales</Link></li>
              <li><Link to="/marketing" className="text-neutral-400 hover:text-orange-500 transition-colors text-sm">Marketing Agency</Link></li>
              <li><Link to="/films" className="text-neutral-400 hover:text-orange-500 transition-colors text-sm">Our Catalogue</Link></li>
              <li><Link to="/faq" className="text-neutral-400 hover:text-orange-500 transition-colors text-sm">FAQ</Link></li>
            </ul>
          </div>

          {/* Platforms */}
          <div>
            <h4 className="font-display text-lg tracking-wider text-white mb-6 uppercase">PLATFORMS</h4>
            <ul className="space-y-3 text-neutral-400 text-sm">
              <li>Amazon Prime Video</li>
              <li>Apple TV</li>
              <li>Tubi</li>
              <li>Fandango</li>
              <li>Plex</li>
              <li>JustWatch</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg tracking-wider text-white mb-6 uppercase">CONTACT</h4>
            <div className="flex items-start gap-3 text-neutral-400 text-sm mb-6">
              <MapPin size={18} className="text-orange-500 mt-0.5 flex-shrink-0" />
              <span>
                LBR Film Distribution<br />
                First Floor, City Centre<br />
                Swan Buildings, 20 Swan St<br />
                Greater Manchester<br />
                M4 5JW
              </span>
            </div>
            <Link 
              to="/contact" 
              className="text-orange-500 hover:text-orange-400 text-sm font-medium"
            >
              Send an Enquiry →
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <div>
            <p className="text-neutral-500 text-sm">
              &copy; {new Date().getFullYear()} LBR Film Distribution. All rights reserved.
            </p>
            <p className="text-neutral-600 text-xs mt-1">
              LBR Film Distribution is a trading name of The Yellow Agency Ltd. Registered in England and Wales.
            </p>
          </div>
          <div className="flex items-center gap-6 text-sm">
            <Link to="#" className="text-neutral-500 hover:text-orange-500 transition-colors">Privacy Policy</Link>
            <Link to="#" className="text-neutral-500 hover:text-orange-500 transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
